export function isMediaPlaying (media) {
  return media && !media.paused && !media.ended && media.playbackRate !== 0 && media.readyState !== 0
}

export function getVideoPlaybackQuality (video) {
  if (!video) return {}
  if (typeof video.getVideoPlaybackQuality === 'function') {
    const info = video.getVideoPlaybackQuality()
    return {
      droppedVideoFrames: info.droppedVideoFrames || info.corruptedVideoFrames,
      totalVideoFrames: info.totalVideoFrames,
      creationTime: info.creationTime
    }
  }

  return {
    droppedVideoFrames: video.webkitDroppedFrameCount,
    totalVideoFrames: video.webkitDecodedFrameCount,
    creationTime: performance.now()
  }
}

export function concatUint8Array (...arr) {
  arr = arr.filter(Boolean)
  const data = new Uint8Array(arr.reduce((p, c) => p + c.byteLength, 0))
  let prevLen = 0
  arr.forEach((d) => {
    data.set(d, prevLen)
    prevLen += d.byteLength
  })
  return data
}

export function softDecodeProbe () {
  let webAudioEnable = false
  let webglEnable = false

  try {
    const AudioContext = window.AudioContext || window.webkitAudioContext
    let ctx = new AudioContext()
    ctx.close()
    ctx = null
    webAudioEnable = true
  } catch (e) {}

  try {
    let cvs = document.createElement('canvas')
    var validContextNames = ['webgl', 'experimental-webgl', 'moz-webgl', 'webkit-3d']
    for (let i = 0; i < validContextNames.length; i++) {
      let glCtx = cvs.getContext(validContextNames[i])
      if (glCtx) {
        glCtx = null
        cvs = null
        webglEnable = true
        break
      }
    }
  } catch (e) {}

  const WebComponentSupported = 'customElements' in window && window.customElements.define
  let isComponentSupport
  if (WebComponentSupported) {
    let Video = window.customElements.get('live-video')
    isComponentSupport = Video && Video.isSupported()
  }

  return webAudioEnable && webglEnable && isComponentSupport
}
